import React from 'react';
import PropTypes from 'prop-types';
import ConnectedFeedbackForm from './ConnectedFeedbackForm';

// TODO: Move to react-viewerbase

function FeedbackRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedFeedbackForm />;
}

FeedbackRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default FeedbackRouting;
